import React from 'react'

interface Props {
  closeWhatsappModal1: () => void
}

const DocumentParserModal: React.FC<Props> = ({ closeWhatsappModal1 }) => {
  return (
    <div className='card w-600px h-600 mb-4 p-2 position-relative text-center'>
      <button
        type='button'
        className='btn-close position-absolute top-0 end-0 m-n4 rounded-circle'
        aria-label='Close'
        onClick={closeWhatsappModal1}
        style={{
          backgroundColor: 'rgba(218, 222, 243)',
          height: '25px',
          width: '25px',
          color: 'rgba(52, 60, 106)'
        }}
      ></button>

      <div className='d-flex flex-column justify-content-center align-items-center h-100'>
        <img
          src='https://preview.keenthemes.com/metronic8/demo39/assets/media/auth/agency.png'
          alt='Under Processing'
          className='mb-3'
          style={{ width: '150px', height: '150px' }}
        />
        <h4 className='text-primary'> Under processing.</h4>
      </div>
    </div>
  )
}

export default DocumentParserModal
